/*
 * View for inspecting and changing the daily refresh schedule of a KB
 */

define(["marionette", "./template/defaultUrlTemplate.html"], function (
  Marionette,
  DefaultUrlTemplate,
) {
  var DefaultUrlView = {};

  DefaultUrlView.defaultUrlView = Marionette.ItemView.extend({
    template: DefaultUrlTemplate,
    modelEvents: {
      sync: "render",
    },
    textboxes: {
      "#defaultContentUrlTextField": {
        enableSelector: ["#defaultContentUrlTextField", ".item-label"],
        modelAttribute: "defaultUrl",
        placeholder: "admin.title.defaultURL",
        textArea: false,
      },
    },
  });

  return DefaultUrlView;
});
